<template>
<!-- 입과 불가자 리스트 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23">{{programName}} <br> 입과 불가자 리스트</p>
                        <a class="pointer float-right layer-close ml-30" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 pt-10">
                            - 입과 불가자 리스트를 확인 할 수 있습니다.
                        </p>
                        <div class="mt-30">
                            <div>
                                <button class="admin-btn-danger" @click="delBanList()">삭제하기</button>
                            </div>
                            <div class="modal-scrollable"> <!-- 추가: 스크롤 가능한 div -->

                                <table class="admin-table-col mt-10">
                                    <colgroup>
                                        <col width="30px">
                                        <col width="50px">
                                        <col width="80px">
                                        <col width="*">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>
                                                <input type="checkbox" v-model="allSelected" @change="allSelect()" name="" id="">
                                            </th>
                                            <th>No</th>
                                            <th>이름</th>
                                            <th>E-mail</th>
                                        </tr>
                                    </thead>
                                    <tbody class="txt-center">
                                        <tr v-for="(item, index) of banList" :key="index" :value="item">
                                            <td>
                                                <input type="checkbox" v-model="item.selected" @change="watchSelected()" name="" id="">
                                            </td>
                                            <td>{{banListLength - index}}</td>
                                            <td>{{item.name}}</td>
                                            <td class="txt-left pl-20">{{item.email}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="pointer admin-btn-default btn ml-05" data-dismiss="modal" aria-label="Close" @click="$emit('close')">확인</a>
                </div>
            </div>
        </div>
        <load-modal v-if="isLoadModalOpened" :parentIdx="parentIdx" @applyProgram="applyProgram" @close="closeModal"></load-modal>
    </div>
</transition>
</template>

<script>
import LoadModal from '@/components/reg/enroll/loadModal.vue'
export default {
    props: ['parentIdx'],
    components: {
        LoadModal,
    },
    data: () => ({
        status: 'none',

        pageIdx: 6, // 프로그램 페이지 순서 idx
        programIdx: 31, // 프로그램 고유 idx

        banList: [], // 입과 불가자 리스트
        banListLength: 0, // 입과 불가자 명수

        allSelected: false, // 전체 체크

        programName: '',
        isLoadModalOpened: false, // 프로그램 선택 모달 (불러오기 시)
    }),

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }
        this.pageIdx = this.parentIdx
        this.isLoadModalOpened = true
    },

    methods: {
        // 입과 불가자 리스트 api 호출
        fetchBanList() {
            var params = {
                pageIdx: this.pageIdx,
                programIdx: this.programIdx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/ban-select', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.banList = res.data.banList
                    this.banListLength = this.banList.length
                } else {
                    this.banList = []
                    this.banListLength = 0
                }
            })
        },

        closeModal() {
            this.isLoadModalOpened = false
        },

        // 입과 불가자 삭제
        delBanList() {
            var idxArray = [] // 삭제할 idx 모집 배열
            for (var item of this.banList) {
                if (item.selected === true) {
                    console.log(item)
                    idxArray.push(item.idx)
                }
            }

            if (idxArray.length === 0) {
                alert('삭제할 리스트를 선택해주세요.')
                return false
            }

            var banIdx = idxArray.join('/')

            let params = new URLSearchParams()
            params.append('banIdx', banIdx)

            this.axios.put(this.axios.root + this.axios.port + '/admin/ban-delete', params).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.fetchBanList()
                    alert(res.data.result)
                } else {
                    alert(res.data.result)
                }
            })
        },

        applyProgram(idx) {
            this.programIdx = idx
            var params = {
                pageIdx: this.pageIdx,
                programIdx: idx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/ban-select', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.banList = res.data.banList
                    this.banListLength = this.banList.length
                } else {
                    alert(res.data.result)
                }
                this.isLoadModalOpened = false
            })
        },

        // 리스트 체크박스 전체선택 / 전체해제
        allSelect() {
            for (var item of this.banList) {
                item.selected = this.allSelected
            }
        },

        // 체크박스 전체선택/전체해제시 테이블의 전체 체크박스 on/off 위함
        watchSelected() {
            var count = 0
            for (var item of this.banList) {
                if (item.selected === true) {
                    count += 1
                }
            }

            if (count === this.banList.length) {
                this.allSelected = true
            } else {
                this.allSelected = false
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
.modal-scrollable {
    max-height: 400px; /* 원하는 최대 높이 설정 */
    overflow-y: auto;  /* 세로 스크롤 추가 */
}
</style>
